import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  IInvoiceSubjectTreeRequest,
  IInvoiceSubjectTreeNode,
  IInvoiceSubjectAddRequest,
  IInvoiceSubjectAddResponse,
  IInvoiceSubjectDeleteRequest,
  IInvoiceSubjectDeleteResponse,
  IInvoiceSubjectEditRequest,
  IInvoiceSubjectEditResponse,
  IInvoiceLibraryParams,
  IInvoiceLibraryItem,
  IInvoiceLibraryListItem,
} from '../../../../types/system/base/invoice';

const hostUrl = getHostbaseUrl();

/**
 * 获取开票科目树状列表
 * @param params 查询参数
 */
export async function getInvoiceSubjectTree(params?: IInvoiceSubjectTreeRequest) {
  try {
    const { code, context, message } = await Http.post<IInvoiceSubjectTreeNode[]>(
      `${hostUrl}/side/sys/invoiceSub/listTree`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 新增开票科目
 * @param params 新增参数
 */
export async function addInvoiceSubject(params: IInvoiceSubjectAddRequest) {
  try {
    const { code, message } = await Http.post<IInvoiceSubjectAddResponse>(
      `${hostUrl}/side/sys/invoiceSub/add`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除开票科目
 * @param params 删除参数
 */
export async function deleteInvoiceSubject(params: IInvoiceSubjectDeleteRequest) {
  try {
    const { code, message } = await Http.post<IInvoiceSubjectDeleteResponse>(
      `${hostUrl}/side/sys/invoiceSub/delete`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 编辑开票科目
 * @param params 编辑参数
 */
export async function editInvoiceSubject(params: IInvoiceSubjectEditRequest) {
  try {
    const { code, message } = await Http.post<IInvoiceSubjectEditResponse>(
      `${hostUrl}/side/sys/invoiceSub/edit`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 根据行业-产品配置查询关联开票科目
 * @param industryId 行业ID
 * @param productId 产品ID
 */
export async function queryInvoiceSubjects(industryId: number, productId: number, dutyType: 0 | 1) {
  try {
    const { code, context, message } = await Http.get<IInvoiceSubjectTreeNode[]>(
      `${hostUrl}/side/sys/invoiceSub/appoint-query`,
      {
        industryId,
        productId,
        dutyType,
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 开票科目库表 - 分页
 */
export async function queryInvoiceLibraryPage(params: IInvoiceLibraryParams) {
  let data = [] as IInvoiceLibraryItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IInvoiceLibraryItem[]; total: number }>(`${hostUrl}/side/invoiceLibrary/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IInvoiceLibraryItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total, 
  };
}

/**
 * 开票科目库表 - 开票科目库名称
 */
export async function queryInvoiceLibraryList() {
  try {
    const { code, context, message } = await Http.post<IInvoiceLibraryListItem[]>(`${hostUrl}/side/invoiceLibrary/list`);
    
    if (code === EAxiosResponseCode.Succeed) {
      return context || [] as IInvoiceLibraryListItem[];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 开票科目库表 - 更新人集合查询
 */
export async function queryInvoiceLibraryListUpdater() {
  try {
    const { code, context, message } = await Http.post<any[]>(`${hostUrl}/side/invoiceLibrary/list/updater`);
    
    if (code === EAxiosResponseCode.Succeed) {
      return context || [] as any[];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

export async function queryInvoiceSubjectList(level: 0 | 1, dutyType: 0|1 = 0) {
  try {
    const { code, context, message } = await Http.post<IInvoiceSubjectTreeNode[]>(
      `${hostUrl}/side/sys/invoiceSub/list`,
      {
        level,
        dutyType, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
